import { fileType } from "./AppConstant";

/**
 * フォルダチェック
 *
 * @type {function}
 */
export const isFolder = (type) => type === fileType.folder;

/**
 * ファイルサイズに応じて単位を追加.
 *
 * @type {function}
 */
export const addByteUnit = (type, byte) => {
  const bytePrefix = 1024;
  const byteUnits = [" B", " KB", " MB", " GB", " TB"];

  if (isFolder(type)) {
    return "-";
  }

  // 引数のチェック
  if (!byte) {
    // 「0 B」を返す
    return 0 + byteUnits[0];
  }

  // 引数のバイトが1024の何乗なのか計算する
  const power = parseInt(Math.floor(Math.log(byte) / Math.log(bytePrefix)), 10);

  // 少数部分が1桁になるように四捨五入し、適切な単位をつける
  const byteNumber = Math.round((byte / bytePrefix ** power) * 10) / 10;
  const byteString = byteNumber.toFixed(1) + byteUnits[power];

  return byteString;
};
